module.exports = __webpack_public_path__ + "img/back-to-vacancy.3f7ab8d9.svg";